export function getCallButtonText(isCallButtonNameExperimentActive: boolean, isLeadFactory: boolean) {
  if (isLeadFactory) {
    return 'Показать контакты';
  }

  return isCallButtonNameExperimentActive ? 'Спросить о ЖК' : 'Контакты застройщика';
}
